import React, {Component} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Footer extends Component {
  
render() {        
  return (
    <div className="Footer">
        <Container>
            <Row>
                <Col sm={11}>Font de les dades: Generalitat de Catalunya amb la col·laboració d'<a href="http://www.amic.media" target="_blank"><img src="https://www.aquibergueda.cat/wp-content/themes/reganto-theme/images/logo-amic-gris.svg" className="logoPeu amic"/></a> · Aquí Berguedà 2021</Col>
                <Col sm={1} className="numVersio">v.1.0.6</Col>
            </Row>
        </Container>
  </div>
  );
}

}

export default Footer; 